__turbopack_context__.v({
  "accordionRoot": "TechnicalSpecs-module__Ow-Oza__accordionRoot",
  "desktopTable": "TechnicalSpecs-module__Ow-Oza__desktopTable",
  "mobileAccordion": "TechnicalSpecs-module__Ow-Oza__mobileAccordion",
  "mobileListView": "TechnicalSpecs-module__Ow-Oza__mobileListView",
  "technicalSpec": "TechnicalSpecs-module__Ow-Oza__technicalSpec",
  "technicalSpecs": "TechnicalSpecs-module__Ow-Oza__technicalSpecs",
  "twoImageSection": "TechnicalSpecs-module__Ow-Oza__twoImageSection",
});
